var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","min-height":"80vh"},attrs:{"id":"iframe1","src":`http://docs.google.com/gview?url=${_vm.mediaUrl + _vm.file_url}&embedded=true`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }